<div *ngIf="priceHistory as phList else loading">
  <p-table #pricehistory
           id="pricehistory"
           [value]="phList"
           [totalRecords]="totalRecords"
           [paginator]="true"
           [rows]="rows"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,20,50,100]"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} записей"
           selectionMode="single"
           [(selection)]="selectedHistoryRow"
           dataKey="VHID"
           styleClass="p-datatable p-datatable-customers p-datatable-gridlines p-datatable-striped"
           [resizableColumns]="true"
           columnResizeMode="fit"
     >
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn style="width: 20%">Дата изменения </th>
        <th pResizableColumn style="width: 20%">Валюта и курс </th>
        <th pResizableColumn style="width: 20%">Цена поставщика до изменения </th>
        <th pResizableColumn style="width: 20%">Входная цена  до изменения </th>
        <th pResizableColumn style="width: 20%">Розничная цена  до изменения </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-ph>
      <tr [pSelectableRow]="ph">
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ph.HDATE | date: 'dd.MM.yyyy'}} </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ph.CURRATE}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{ph.VPRICE | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{ph.IPRICE | number:'1.2-2' }}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  text-align: right">{{ph.UPRICE | number:'1.2-2' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Нет данных для загрузки</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #loading>
  <p>Информация о товарах загружается...</p>
</ng-template>
